import {
  APP_ID,
  APP_VERSION_H5,
  APP_VERSION_MINI,
  APP_VERSION_WEB,
} from '@whelk/const/src/appInfo';
import {
  LocalDeviceIdKey,
  LocalUuidKey,
  NATIVE_NETWORK_PUBLIC_PARAMS,
  NATIVE_NETWORK_PUBLIC_HEADER,
} from '@whelk/const/src/token';
import { browserName, osName } from '@whelk/utils/src/checkUA';

// ssr 需要的数据
export const generatePublicParams = (ua?: any) => {
  const isMiniProgram = ua?.includes('miniProgram');
  const isMobile =
    ua?.includes('android') ||
    ua?.includes('webos') ||
    ua?.includes('iphone') ||
    ua?.includes('ipod') ||
    ua?.includes('ipad') ||
    ua?.includes('blackberry') ||
    ua?.includes('harmonyos');
  let version_code = APP_VERSION_WEB;
  if (isMobile) {
    version_code = APP_VERSION_H5;
  } else if (isMiniProgram) {
    version_code = APP_VERSION_MINI;
  } else
    return {
      device_platform: 'web',
      biz_id: 2, // 2代表文本
      app_id: APP_ID,
      version_code: version_code,
      lang: process.env['NEXT_PUBLIC_LOCALE'] ?? 'zh-Hans',
    };
};

// 以下都是在ssr server端请求的时候拿不到的数据
export const handleGeneralParams = (time: number) => {
  const params = { ...generatePublicParams() } as any;
  params.uuid = localStorage.getItem(LocalUuidKey);
  params.device_id = localStorage.getItem(LocalDeviceIdKey);

  params.os_name = osName;
  params.browser_name = browserName;

  // @ts-ignore
  if (navigator?.deviceMemory) {
    // @ts-ignore
    params.device_memory = navigator.deviceMemory;
  }
  if (navigator?.hardwareConcurrency) {
    params.cpu_core_num = navigator?.hardwareConcurrency;
  }

  if (navigator?.language) {
    params.browser_language = navigator.language;
  }

  if (navigator?.platform) {
    params.browser_platform = navigator.platform;
  }

  params.screen_width = screen?.width;
  params.screen_height = screen?.height;
  params.unix = time;
  return params;
};

export const addFetchUrlPublicParams = (url: string, params: any) => {
  const searchParams = new URLSearchParams(params)?.toString();
  const hasSearch = url?.includes('?');
  return hasSearch ? `${url}&${searchParams}` : `${url}?${searchParams}`;
};

// native
export const getNativeNetworkParams = (time: number) => {
  try {
    let params = {} as any;
    const queryMapString = localStorage.getItem(NATIVE_NETWORK_PUBLIC_PARAMS) ?? '';
    const queryMap = JSON.parse(queryMapString) ?? {};
    params = {
      yy_platform: 'h5',
      ...queryMap,
      unix: time,
    };
    return params;
  } catch (err) {
    return {
      unix: time,
    };
  }
};

export const getNativePublicHeader = () => {
  try {
    const headerStr = localStorage.getItem(NATIVE_NETWORK_PUBLIC_HEADER) ?? '';
    const header = JSON.parse(headerStr) ?? {};
    return header;
  } catch (err) {
    return {};
  }
};
